export default {
  TOAST_TYPE_DELETE: 'delete',
  TOAST_TYPE_ADD: 'add'
}
